import axios from 'axios';

const axiosInstance = axios.create({
  
  baseURL: process.env.REACT_APP_API_URL, // adapte selon ton env  
  timeout: 10000 // 10 secondes
  
});

export default axiosInstance;